import React from "react";

import "./Header.scss";

export const Header: React.FC = () => {
  return (
    <header className="header-page">
      <div className="site-title h1">
        <span className="carrot">Password Bam!</span>
      </div>
      <div className="site-tagline">That's... so... random... 🤣</div>
    </header>
  );
};
